import React from 'react';
import { useSelector } from 'react-redux';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_BULK_CREATE, FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import Button from 'shared/ui/Button';
import {
  Wrapper, Label, Image, ButtonLink
} from './styled';

const EmptyVulns = ({ toggleModalUploadVulns, toggleModalCreateVuln, image }) => {
  const manualCreationAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.CREATE));
  const importVulnsAllowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_BULK_CREATE, PERMISSION_TYPES.CREATE));

  return (
    <Wrapper>
      <Image src={ image } />
      <Label>You don’t have any vulnerabilities yet.</Label>
      { importVulnsAllowedByRole &&
          <Button onClick={ toggleModalUploadVulns }>Upload Vulnerabilities</Button>
      }
      { manualCreationAllowedByRole &&
          <Label>
            { importVulnsAllowedByRole && 'Or' }
            <ButtonLink onClick={ toggleModalCreateVuln }>Create vulnerabilities manually</ButtonLink>
          </Label>

      }
    </Wrapper>
  );
};

export default EmptyVulns;
